let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5p8Up")).then(() => parcelRequire('iYtwG'));